import React from "react";
import { Dialog, Button, CloseIcon } from "@fluentui/react-northstar";
import { DocumentAddFilled } from "@fluentui/react-icons";
import useLogicDialogAddDocument from "../../hooks/useLogicDialogAddDocument";
import DialogAddDocumentContent from "./DialogAddDocumentContent";
import { FormProvider } from "react-hook-form";
import { QUERY_KEY_DOCUMENTS_HR_GET_FILES } from "../../hooks/useLogicDocumentsHr";

const DialogAddDocument = ({
    showAdditionalInformation = true,
    showActions = true,
    onSuccess = () => null,
    queryKeyToRefesh = QUERY_KEY_DOCUMENTS_HR_GET_FILES,
}) => {
    const { open, closeDialog, openDialog, dz, methods, mutation, form } =
        useLogicDialogAddDocument({
            onSuccess,
            showAdditionalInformation,
            queryKeyToRefesh,
            showActions,
        });

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(mutation.onSubmit)}>
                <Dialog
                    open={open}
                    header={"Ajouter des documents"}
                    content={
                        <DialogAddDocumentContent
                            showAdditionalInformation={
                                showAdditionalInformation
                            }
                            dz={dz}
                        />
                    }
                    confirmButton={{
                        content: "Ajouter le(s) document(s)",
                        type: "submit",
                        flat: true,
                        loading: mutation.isLoading,
                        disabled: form.disable_confirm_button,
                    }}
                    cancelButton={{
                        content: "Annuler",
                        flat: true,
                    }}
                    onCancel={() => {
                        closeDialog();
                        return;
                    }}
                    onConfirm={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        return methods.handleSubmit(mutation.onSubmit)();
                    }}
                    trigger={
                        <Button
                            onClick={(e) => {
                                e.preventDefault();
                                return openDialog();
                            }}
                            icon={<DocumentAddFilled fontSize={20} />}
                            content="Ajouter des documents"
                            primary
                            flat
                        />
                    }
                    headerAction={{
                        icon: <CloseIcon />,
                        iconOnly: true,
                        title: "Fermer",
                        onClick: closeDialog,
                    }}
                    styles={{
                        width: "764px",
                    }}
                />
            </form>
        </FormProvider>
    );
};

export default DialogAddDocument;
